















































































import Vue from 'vue';

import { MDCRipple } from '@material/ripple';

import { InternalFile } from './filePreview.vue';

import { resizeImage } from '../../libs/resizeImage';

import 'cropperjs/dist/cropper.css';
import Cropper from 'cropperjs';
import { setTimeout } from 'timers';

interface Data {
  file: InternalFile;
  buttons: MDCRipple[];

  cropper: Cropper;
}

export default Vue.extend({
  data(): Data {
    return {
      buttons: [] as MDCRipple[],
    } as Data;
  },
  props: [
    'imgURL',
    'img',
  ],
  mounted() {
    this.file = this.img;

    for (const button of this.$el.querySelectorAll('.mdc-button')) {
      const btn = button as HTMLElement;
      this.buttons.push(new MDCRipple(btn));
    }

    const image = this.$el.querySelector('img') as HTMLImageElement;
    image.onload = async () => {
      if (image.width > 800) {
        await resizeImage(image, 800);
      }

      const startCropper = () => {
        this.cropper = new Cropper(image, {
          viewMode: 1,
          aspectRatio: 16 / 9,
          minContainerHeight: 350,
          autoCropArea: 1,
        });
      };

      if (image.complete) {
        startCropper();
      } else {
        image.onload = startCropper;
      }
    };

  },
  beforeDestroy() {
    for (const button of this.buttons) {
      button.destroy();
    }

    this.cropper.destroy();
  },
  updated() { return; },
  methods: {
    crop(keep: boolean): HTMLCanvasElement {
      this.cropper.crop();
      const croppedImage = this.cropper.getCroppedCanvas({
        // fillColor: '#fff',
        imageSmoothingEnabled: false,
        imageSmoothingQuality: 'high',

      } as any);

      if (!keep) {
        this.cropper.replace(croppedImage.toDataURL());
      }

      return croppedImage;
    },
    save() {
      const croppedImage = this.crop(true);
      const parent = this.$parent as any;
      parent.imageUpdatedFromEditor(croppedImage);
    },
    cancel() {
      const parent = this.$parent as any;
      parent.cancelFromEditor();
    },
    rt90() {
      this.cropper.rotate(-90);
    },
    rtl() {
      this.cropper.rotate(-5);
    },
    rtr() {
      this.cropper.rotate(5);
    },
  },
  components: {
  },
});
